import { twMerge } from 'tailwind-merge';
import Title from '@/components/Title';
import { PaymentIcon } from '@/icons';
import Card from '@/components/Card';
import { renderPrice } from '@/utils/strings';
import { classes } from '../utils';

export type TotalInvestedCardProps = {
  className?: string;
  currency?: string;
  totalInvested: number;
};

export default function TotalInvestedCard({
  className,
  currency = 'EUR', // TODO
  totalInvested,
}: TotalInvestedCardProps) {
  return (
    <Card className={twMerge(classes.card, className)}>
      <div className={classes.textWrapper}>
        <div className={classes.label}>Total Invested</div>
        <Title size="md">
          {renderPrice(totalInvested, { currency, concise: true })}
        </Title>
      </div>
      <div className={twMerge(classes.icon, classes.paymentIcon)}>
        <PaymentIcon />
      </div>
    </Card>
  );
}
